<template>
  <div class="audio-controls">
    <volume-controls/>
    <div class="audio-controls__track-info">
      <span>{{ truncatedTrackName }}</span>
      <div>
        <div v-if="!showWaveform">
          <span class="audio-controls__link" @click="emits('toggleWaveform')">Trim</span>
          <span>&nbsp; /&nbsp; </span>
          <file-selector
            :accept="audioAccept"
            @file-selected="onFileSelected"
          >
            <span
              class="audio-controls__link"
              v-show="!isAudioLoading">Change</span>
          </file-selector>
        </div>
        <div v-else>
          <span class="audio-controls__link" @click="emits('resetTrim')">Reset</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue'
import useWidthLimitedFileName from '@/composables/UseWidthLimitedFileName'
import { defaultTrackFontSize } from '@/composables/UseWidthLimitedFileName'
import FileSelector from '@/components/common/FileSelector.vue'
import { audioAccept } from '@/static/file-types'
import VolumeControls from '@/components/preview/VolumeControls.vue'

const props = defineProps<{
  isAudioLoading: boolean
  trackName: string
  showWaveform: boolean
}>()

const {
  trackName
} = toRefs(props)

const emits = defineEmits<{
  (event: 'fileSelected', file: File): void,
  (event: 'toggleWaveform'): void
  (event: 'resetTrim'): void
}>()

const truncatedTrackName = useWidthLimitedFileName(trackName)

const onFileSelected = (file: File) => {
  emits('fileSelected', file)
}
</script>

<style lang="scss">
.audio-controls {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 7px;
  color: $grey-50;
  font-size: v-bind(defaultTrackFontSize);

  &__track-info {
    margin-top: 2px;
  }

  &__link {
    color: $link-blue;
    cursor: pointer;
    text-decoration: underline dashed transparent;
    transition: text-decoration 150ms $animationCurve;

    &:hover {
      text-decoration: underline dashed currentColor;
    }
  }
}
</style>
